import { format } from "date-fns";
import type { AiFeedbackChatVote } from "@superagents/types/api";
import { formatDateAsBadge } from "@/shared/utils/date";

/**
 * Nome completo de quem avaliou (SA-1485, R5: dois "Bruno" na mesma conta
 * precisam ser distinguíveis); `null` sem autor ou sem nome.
 */
export function authorFullName(
  author: { name: string | null } | null | undefined
): string | null {
  const name = author?.name?.trim().replace(/\s+/g, " ");
  return name || null;
}

/** "hoje às 14:32", "ontem às 09:10", "segunda-feira às 18:00", "03/10/2026 às 11:05". */
export function feedbackDateLabel(iso: string): string {
  const date = new Date(iso);
  const day = formatDateAsBadge(date);
  return `${day.charAt(0).toLowerCase()}${day.slice(1)} às ${format(date, "HH:mm")}`;
}

/** Título do like travado: quem já avaliou a resposta. */
export function likeLockedTitle(vote: AiFeedbackChatVote): string {
  if (vote.mine) return "Você já enviou um feedback para esta resposta";
  const name = authorFullName(vote.author);
  return name
    ? `${name} já enviou um feedback para esta resposta`
    : "Esta resposta já tem um feedback";
}

/** Título do like de outra pessoa: o admin desfaz, os outros só leem. */
export function otherLikeTitle(vote: AiFeedbackChatVote): string {
  const name = authorFullName(vote.author);
  if (vote.editable) {
    return name ? `Desfazer a avaliação de ${name}` : "Desfazer a avaliação";
  }
  return name
    ? `${name} avaliou como boa resposta`
    : "Outra pessoa avaliou como boa resposta";
}
